import { UserRoleEnum } from '@enums/user-role.enum';

export const EventConstant = {
    assignLegEvent: "assignLegEvent",
    incomingMessageCountEvent: "incomingMessageCountEvent",
    fetchMessageEvent: "fetchMessageEvent",
    changeLegStatusEvent: "changeLegStatusEvent",
    removeLegAssignmentEvent: "removeLegAssignmentEvent",
    serviceRequestCreatedEvent: "serviceRequestCreatedEvent",
    driverShiftEvent: "driverShiftEvent",
    vendorAssignmentRequestEvent: "vendorAssignmentRequestEvent",
    serviceRequestStatusUpdateEvent: "ServiceRequestStatusUpdateEvent",
    legDeletionEvent: "LegDeletionEvent",
    internalGroupChatSendMessageEvent: "InternalGroupChatSendMessageEvent",
    createGroupEvent: "CreateGroupEvent",
    deleteGroupEvent: "DeleteGroupEvent",
    updateLegTimeStampEvent: "UpdateLegTimeStampEvent",
    customersRequestChangeEvent: "CustomersRequestChangeEvent",
    assignedFeedbackCountEvent: "AssignedFeedbackCountEvent",
    customersPendingRequestsChangeEvent: "CustomersPendingRequestsChangeEvent",
    notificationsUpdateEvent: 'NotificationsUpdateEvent',
    serviceRequestApprovedOrRejectedEvent: 'ServiceRequestApprovedOrRejectedEvent',
    internalTripNotificationEvent: "InternalNotificationEvent",
    itineraryReadyEvent: "ItineraryReadyEvent",
    serviceRequestFlagEvent: "SRFlagEvent",
};

export const serverTimeoutInMilliseconds: number = 240000; //4 minutes
export const maxRetries: number = 3;

export const EventMap: string[] = [
  EventConstant.assignLegEvent,
  EventConstant.incomingMessageCountEvent,
  EventConstant.fetchMessageEvent,
  EventConstant.changeLegStatusEvent,
  EventConstant.removeLegAssignmentEvent,
  EventConstant.serviceRequestCreatedEvent,
  EventConstant.driverShiftEvent,
  EventConstant.vendorAssignmentRequestEvent,
  EventConstant.serviceRequestStatusUpdateEvent,
  EventConstant.legDeletionEvent,
  EventConstant.internalGroupChatSendMessageEvent,
  EventConstant.createGroupEvent,
  EventConstant.deleteGroupEvent,
  EventConstant.updateLegTimeStampEvent,
  EventConstant.customersRequestChangeEvent,
  EventConstant.assignedFeedbackCountEvent,
  EventConstant.customersPendingRequestsChangeEvent,
  EventConstant.notificationsUpdateEvent,
  EventConstant.serviceRequestApprovedOrRejectedEvent,
  EventConstant.internalTripNotificationEvent,
  EventConstant.itineraryReadyEvent,
];

export const RoleEventMap: { [key: string]: string[] } = {
    [UserRoleEnum.EXECUTIVE_ADMIN]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.incomingMessageCountEvent,
        EventConstant.serviceRequestCreatedEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.driverShiftEvent,
        EventConstant.legDeletionEvent,
        EventConstant.fetchMessageEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.serviceRequestFlagEvent,
        EventConstant.assignedFeedbackCountEvent
    ],
    [UserRoleEnum.COORDINATOR]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.incomingMessageCountEvent,
        EventConstant.serviceRequestCreatedEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.driverShiftEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.legDeletionEvent,
        EventConstant.fetchMessageEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.customersPendingRequestsChangeEvent,
        EventConstant.internalTripNotificationEvent,
        EventConstant.serviceRequestFlagEvent,
        EventConstant.assignedFeedbackCountEvent
    ],
    [UserRoleEnum.MANAGEMENT]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.incomingMessageCountEvent,
        EventConstant.serviceRequestCreatedEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.driverShiftEvent,
        EventConstant.legDeletionEvent,
        EventConstant.fetchMessageEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.customersPendingRequestsChangeEvent,
        EventConstant.internalTripNotificationEvent,
        EventConstant.serviceRequestFlagEvent,
        EventConstant.assignedFeedbackCountEvent
    ],
    [UserRoleEnum.DRIVER]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.driverShiftEvent,
        EventConstant.legDeletionEvent,
        EventConstant.assignedFeedbackCountEvent
    ],
    [UserRoleEnum.ACCOUNTING]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.assignedFeedbackCountEvent,
    ],
    [UserRoleEnum.INTERNAL_READONLY]: [
        EventConstant.changeLegStatusEvent,
        EventConstant.assignedFeedbackCountEvent,
    ],
    [UserRoleEnum.CUSTOMER_ADMIN]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.customersRequestChangeEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.notificationsUpdateEvent,
        EventConstant.itineraryReadyEvent,
    ],
    [UserRoleEnum.CUSTOMER_COORDINATOR]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.customersRequestChangeEvent,
        EventConstant.serviceRequestStatusUpdateEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.updateLegTimeStampEvent,
        EventConstant.notificationsUpdateEvent,
        EventConstant.itineraryReadyEvent,
    ],
    [UserRoleEnum.VENDOR_ADMIN]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.vendorAssignmentRequestEvent
    ],
    [UserRoleEnum.VENDOR_COORDINATOR]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.vendorAssignmentRequestEvent
    ],
    [UserRoleEnum.VENDOR_DRIVER]: [
        EventConstant.internalGroupChatSendMessageEvent,
        EventConstant.createGroupEvent,
        EventConstant.deleteGroupEvent,
        EventConstant.changeLegStatusEvent,
        EventConstant.assignLegEvent,
        EventConstant.removeLegAssignmentEvent,
        EventConstant.driverShiftEvent,
        EventConstant.legDeletionEvent
    ],
};
